import http from '@/http'

export default {
  donate: data => http.post('/api/donations', data)
}
